// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchFilter_wrapper__5GZqU","title":"SearchFilter_title__yIqIq","list":"SearchFilter_list__SScpM"};